import React from "react"

//Helpers
import { classes } from "../../../../helpers/classname"

//Styled
import style from "./style.module.scss"

const { Button, disable } = style

const ButtonComponent = ({ checked, onClick }) => {
  return (
    <div
      className={classes(Button, checked ? "" : disable)}
      onClick={checked ? onClick : () => {}}
    >
      ПОЇХАЛИ!
    </div>
  )
}

export default ButtonComponent
